export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
    CONFIRM:'CONFIRM',
    CLEAR_CONFIRM:'CLEAR_CONFIRM'
};
